import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Row } from "reactstrap";

interface IProps {
  formik: any;
  setShowModalConfirm: (data: boolean) => void;
  handleClose: () => void;
}

export const HaveProblemButtons = (props: IProps) => {
  const { formik } = props;

  return (
    <Row>
      <Col className="col-buttons-group">
        <Button
          className="btn-previous"
          name="previous"
          onClick={props.handleClose}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          Volver
        </Button>

        <Button
          className="btn-next"
          name="send"
          disabled={!formik.isValid}
          onClick={() => props.setShowModalConfirm(true)}
        >
          Enviar
          <FontAwesomeIcon icon={faArrowRight} />
        </Button>
      </Col>
    </Row>
  );
};
